import { Box, Checkbox, Collapse, FormControlLabel, Stack, TextField, Tooltip } from '@mui/material'
import { t } from 'i18next'
import { debounce } from 'lodash'
import React from 'react'

type MoreFieldsSectionProps = {
    open: boolean,
    handleCommentChange: (text: string) => void,
    comment?: string,
    isReference?: boolean,
    onChangeReference: (value: boolean) => void
}

function MoreFieldsSection({ open, handleCommentChange, comment, isReference, onChangeReference }: MoreFieldsSectionProps) {

    const onFieldChange = debounce((e: React.ChangeEvent<HTMLInputElement>) => {
        handleCommentChange(e.target.value)
    }, 500)

    return (
        <Collapse in={open}>
            <Stack direction={'column'} spacing={1} my={2}>
                <TextField defaultValue={comment} multiline rows={2} onChange={onFieldChange} label={t('editTrainingForm:comment:label')} fullWidth></TextField>
                <div>
                    <Tooltip title={t('training:markAsReferenceHint')} arrow placement='bottom'>
                        <FormControlLabel checked={isReference} onChange={(_, checked) => onChangeReference(checked)} control={<Checkbox />} label={t('training:markAsReference')} />
                    </Tooltip>
                </div>
            </Stack>
        </Collapse>
    )
}

export default MoreFieldsSection